export default __webpack_public_path__ + "static/media/265.29b31b69.jpg";